<template>
  <billing-report-panel
    report-key="billing-funnel"
    route="/reports/billing-funnel"
    file-name="producao-faturado-recebido.xlsx"
    period-label="Período da competência"
    :columns="columns"
    :default-days="180"
  />
</template>

<script>
import BillingReportPanel from './BillingReportPanel.vue';

export default {
  components: {
    BillingReportPanel,
  },
  data() {
    return {
      columns: [
        'Competência',
        'Produzido',
        'Faturado em lote fechado',
        'Glosado',
        'Recebido',
        'Faturado sobre o produzido',
        'Recebido sobre o faturado',
        'Total do período',
      ],
    };
  },
};
</script>
